import React from 'react'

import { LKModalTrigger } from '../../LKModal'

const LoanTransactionDisburseTrigger = ({ children, params }) => (
  <LKModalTrigger name="LoanTransactionDisburse" alias="disburse" params={params} permission="LOAN_DISBURSE">
    {children}
  </LKModalTrigger>
)

export default LoanTransactionDisburseTrigger
